module.exports = __webpack_public_path__ + "img/LATIN10_29.f8712b9a.jpg";